import { Link } from "react-router-dom";
import { XCircle } from "@phosphor-icons/react";

const PaymentCancel = () => (
  <div data-testid="payment-cancel-page" className="mx-auto flex min-h-[80vh] max-w-sm flex-col items-center justify-center px-4 py-16 text-center">
    <XCircle size={32} weight="bold" className="mb-4 text-zinc-500" />
    <h1 className="font-heading text-xl uppercase text-white">Checkout Canceled</h1>
    <p className="mt-2 text-sm text-zinc-500">No charge was made. You can subscribe whenever you&rsquo;re ready.</p>
    <Link
      to="/subscribe"
      data-testid="payment-cancel-retry-link"
      className="mt-6 rounded-md bg-eb-accent px-4 py-2 font-heading text-sm uppercase tracking-wide text-white transition-colors hover:bg-blue-600"
    >
      Back to Plans
    </Link>
  </div>
);

export default PaymentCancel;
